import { Button, Divider } from '@billy/design-system'
import { ReactElement } from 'react'
import { Path } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { FormItemProps } from '../../../../../../../hooks'
import { CompanyInfo, CompanyInfoSchema } from '../../../utils'
import { AddressingLineFormat } from '../../AddressingLineSelector/types/frAddressingLinesFormats'
import { CompanyMissingFields } from '../../CompanyMissingFields'
import { ManualCompanyForm } from '../../ManualCompanyForm'
import { MatchedInformation } from '../../MatchedInformation'

interface MatchedInformationCardProps {
  addressingLineFormat: AddressingLineFormat
  formItem: <Name extends Path<CompanyInfo>>(
    props: Omit<FormItemProps<CompanyInfoSchema, Name>, 'error'>,
  ) => JSX.Element
  values: CompanyInfo
  isFormEmpty: boolean
  missingAutoFields: string[]
  toggleManualCompanyForm: boolean
  onManualCompanyFormToggle: () => void
}

export const MatchedInformationCard = ({
  addressingLineFormat,
  formItem,
  isFormEmpty,
  values,
  missingAutoFields,
  toggleManualCompanyForm,
  onManualCompanyFormToggle,
}: MatchedInformationCardProps): ReactElement => {
  const { t } = useTranslation()

  if (toggleManualCompanyForm) {
    return (
      <>
        <Divider>{t('e_invoice.kyc.step.company_details.divider.text')}</Divider>
        <ManualCompanyForm addressingLineFormat={addressingLineFormat} formItem={formItem} />
      </>
    )
  }

  if (isFormEmpty) {
    return (
      <>
        <Divider>{t('e_invoice.kyc.step.company_details.divider.text')}</Divider>
        <Button variant="text" onClick={onManualCompanyFormToggle}>
          {t('e_invoice.kyc.step.company_details.add_company_manually.button.label')}
        </Button>
      </>
    )
  }

  return (
    <>
      <MatchedInformation missingFields={missingAutoFields} values={values} />
      {Boolean(missingAutoFields?.length) && (
        <CompanyMissingFields
          addressingLineFormat={addressingLineFormat}
          missingFields={missingAutoFields}
          formItem={formItem}
        />
      )}
    </>
  )
}
